import cs from 'classnames';

import type { IChipProps } from '@/DesignSystem/Model/DataModel';

export const generateChipClassNames = ({ className, color, radius, bold, size }: Omit<IChipProps, 'title'>) => {
  return cs(
    'ui__chip',
    size && `ui__chip--size-${size}`,
    color && `ui__chip--color-${color}`,
    radius && `ui__chip--radius-${radius}`,
    bold && `ui__chip--bold`,
    className,
  );
};
